import * as actions from 'Actions';
import { saveError } from 'Api';
import Endpoints from 'Api/endpoints';
import {
  apiToSingularConnections,
  apiToSingularRoot,
  capitalSingularInventory,
  displaySingularInventory,
} from 'Constants/displayConstants';
import Checkbox from 'Utils/Checkbox';
import Dialog from 'material-ui/Dialog';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import Toggle from 'material-ui/Toggle';
import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';
import { connect } from 'react-redux';
import originalTerminologies from '../../../helper_functions/originalTerminologies';
import { handleErrorMessage } from '../../../helper_functions/errors/handleErrorMessages';

const styles = {
  thumbOn: {
    backgroundColor: '#278ADA',
  },
  trackOn: {
    backgroundColor: '#278ADA',
    opacity: '0.5',
  },
  thumbOff: {
    backgroundColor: '#0E2C44',
  },
  trackOff: {
    backgroundColor: '#0E2C44',
    opacity: '0.5',
  },
};

class ShareItemContainer extends Component {
  state = {
    multilocationShared: false,
    disableModalOpen: false,
    itemGroup: {
      name: '',
    },
    itemGroupNames: [],
    checks: [false, false, false, false],
    shareOption: 'already_shared',
  };

  UNSAFE_componentWillMount() {
    const { product } = this.props;
    this.setState({
      multilocationShared: product.multilocationShared,
    });

    this.getItemGroupNames();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { product } = nextProps;
    this.setState({
      multilocationShared: product.multilocationShared,
    });
  }

  toggleMultilocationShared = () => {
    const {
      product,
      productType,
      openLoadingSpinner,
      closeLoadingSpinner,
      setProductFromResponse,
    } = this.props;

    const newMultilocationShared = !this.state.multilocationShared;
    if (newMultilocationShared) {
      openLoadingSpinner('Enabling multilocation sharing...');
      Endpoints.multilocation.products
        .enableSharing(product, productType)
        .then((response) => {
          this.setState({
            multilocationShared: newMultilocationShared,
          });
          closeLoadingSpinner();
          setProductFromResponse(
            apiToSingularConnections[productType],
            product.id,
            response
          );
        })
        .catch((error) => {
          const errors = error.response.data;
          const { setErrors } = this.props;
          closeLoadingSpinner();
          saveError(error);
          setErrors(errors);
        });
    } else {
      this.setState({
        disableModalOpen: true,
      });
    }
  };
  generateSharedItem = () => {
    const { product, productType } = this.props;
    const {
      setErrors,
      openLoadingSpinner,
      closeLoadingSpinner,
      openSuccessSnackBar,
      setProductFromResponse,
    } = this.props;

    openLoadingSpinner(`Sharing new ${this.capitalTerminology()}...`);
    Endpoints.multilocation.products
      .generateSharedItem(product, productType)
      .then((response) => {
        setProductFromResponse(
          apiToSingularConnections[productType],
          product.id,
          response
        );
        this.setState({
          disableModalOpen: false,
          checks: [false, false, false, false],
        });
        openSuccessSnackBar(
          `Successfully shared ${this.capitalTerminology()}.`
        );
      })
      .catch((error) => {
        saveError(error);
        setErrors(
          handleErrorMessage(
            error?.response?.data,
            `Error creating shared ${this.capitalTerminology()}`
          )
        );
      })
      .finally(() => {
        closeLoadingSpinner();
      });
  };

  autocompleteItemGroups = (event, value) => {
    this.getItemGroupNames(value);
    this.setState({ itemGroup: { name: value } });
  };

  handleCheckbox = (index, isChecked) => {
    this.setState((prevState) => {
      const newChecks = [...prevState.checks];
      newChecks[index] = isChecked;

      return { checks: newChecks };
    });
  };

  validate = () => {
    const { checks } = this.state;

    let allMarked = true;

    for (let check of checks) {
      if (!check) {
        allMarked = false;
        break;
      }
    }

    return allMarked;
  };

  handleClose = () => {
    this.setState({
      disableModalOpen: false,
    });
  };

  disableSharing = () => {
    const { product, productType } = this.props;
    const {
      closeLoadingSpinner,
      setProductFromResponse,
      setErrors,
    } = this.props;
    const allMarked = this.validate();

    if (allMarked) {
      Endpoints.multilocation.products
        .disableSharing(product, productType)
        .then((response) => {
          closeLoadingSpinner();
          setProductFromResponse(
            apiToSingularConnections[productType],
            product.id,
            response
          );
          this.setState({
            disableModalOpen: false,
            checks: [false, false, false, false],
          });
        })
        .catch((error) => {
          closeLoadingSpinner();
          this.setState({
            disableModalOpen: false,
            checks: [false, false, false, false],
          });
          saveError(error);
          setErrors(error.response.data);
        });
    } else {
      setErrors('Must check all checkboxes before you can submit.');
    }
  };

  getItemGroupNames = (query = '*') => {
    const { productType } = this.props;
    const component = this;
    Endpoints.multilocation.inventoryGroups
      .names(productType, { per: 10, query })
      .then((response) => {
        component.setState({
          itemGroupNames: response.data.names,
        });
      })
      .catch((error) => {
        saveError(error);
      });
  };

  handleItemGroupSelect = (value, itemGroup) => {
    this.setState({ itemGroup });
  };

  shouldItemGroupRender(itemGroup, value) {
    return itemGroup.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
  }

  linkItemToGroup = () => {
    const { product, productType } = this.props;
    const {
      setProductFromResponse,
      openLoadingSpinner,
      closeLoadingSpinner,
    } = this.props;
    const { itemGroup } = this.state;

    if (!itemGroup.id) {
      this.props.setErrors({
        itemGroup:
          'Please select an item from search results to add to or click the button to share a new item.',
      });
    } else {
      const data = {
        [`${apiToSingularRoot[productType]}_group_id`]: itemGroup.id,
      };
      openLoadingSpinner('Linking Item to Group...');
      Endpoints.multilocation.products
        .connectToGroup(product, productType, data)
        .then((response) => {
          closeLoadingSpinner();
          setProductFromResponse(
            apiToSingularConnections[productType],
            product.id,
            response
          );
        })
        .catch((error) => {
          closeLoadingSpinner();
          saveError(error);
        });
    }
  };

  capitalTerminology = () => {
    const { productType } = this.props;
    const { purchaseSingular } = originalTerminologies();
    const capitalTerminology = ['addOns', 'addons'].includes(productType)
      ? purchaseSingular
      : capitalSingularInventory[productType];

    return capitalTerminology;
  };

  displayTerminology = () => {
    const { productType } = this.props;
    const { purchaseSingular } = originalTerminologies();
    const displayTerminology = ['addOns', 'addons'].includes(productType)
      ? purchaseSingular
      : displaySingularInventory[productType];

    return displayTerminology;
  };

  render() {
    const checkLabels = [
      'Your inventory numbers and sharing will be turned off.',
      'Inventory you are sharing with other locations will go away.',
      'Ability to move inventory between locations will be disabled.',
      'Rentals using multilocation will switch to subrentals.',
    ];

    const { product } = this.props;
    const {
      multilocationShared,
      itemGroup,
      itemGroupNames,
      disableModalOpen,
      checks,
      shareOption,
    } = this.state;

    return (
      <section className='shareItem'>
        <h4>Share {this.capitalTerminology()}</h4>
        <p className='justify'>
          Shared inventory is accessible across multiple locations, which can be
          used to subrent between locations or to keep track of inventory that
          is used in more than one location
        </p>
        <div className='viewToggle'>
          <Toggle
            id='item_sharing_toggle'
            className='toggle-ml-0'
            onToggle={this.toggleMultilocationShared}
            toggled={multilocationShared}
            thumbStyle={styles.thumbOff}
            trackStyle={styles.trackOff}
            thumbSwitchedStyle={styles.thumbOn}
            trackSwitchedStyle={styles.trackOn}
          />
          Share {this.displayTerminology()}
        </div>
        {product.multilocationShared && (
          <div>
            {product.groupInfo && (
              <div>
                Your {this.displayTerminology()} is being shared as:
                <div className='alias'>
                  <strong>{product.groupInfo.groupName}</strong>
                </div>
              </div>
            )}
            <form className='form'>
              <RadioButtonGroup
                name='shareOption'
                className='radioList'
                onChange={(e) => this.setState({ shareOption: e.target.value })}
                valueSelected={shareOption}
              >
                <RadioButton
                  className='radio'
                  value='new_shared'
                  label={`Create new ${this.displayTerminology()} for other location(s)`}
                />
              </RadioButtonGroup>

              {shareOption == 'new_shared' && (
                <div className='fields'>
                  <a
                    id='share_new_item'
                    className='btn full'
                    onClick={this.generateSharedItem}
                  >
                    Create & Share New {this.capitalTerminology()}
                  </a>
                </div>
              )}
              <RadioButtonGroup
                name='shareOption'
                className='radioList'
                onChange={(e) => this.setState({ shareOption: e.target.value })}
                valueSelected={shareOption}
              >
                <RadioButton
                  className='radio'
                  value='already_shared'
                  label={`Share with existing ${this.displayTerminology()} in other location(s)`}
                />
              </RadioButtonGroup>
              {shareOption == 'already_shared' && (
                <div className='fields'>
                  <Autocomplete
                    value={itemGroup.name}
                    inputProps={{
                      id: 'item-autocomplete',
                      placeholder: `Search for existing ${this.displayTerminology()}`,
                      type: 'text',
                    }}
                    wrapperProps={{ className: 'autocomplete search' }}
                    items={itemGroupNames}
                    getItemValue={(itemGroup) => itemGroup.name}
                    onChange={this.autocompleteItemGroups}
                    onSelect={this.handleItemGroupSelect}
                    renderMenu={(children) => (
                      <ul className='results'>{children}</ul>
                    )}
                    shouldItemRender={this.shouldItemGroupRender}
                    renderItem={(itemGroup, isHighlighted) => {
                      return (
                        <li
                          className={`${isHighlighted ? 'highlight' : ''}`}
                          key={itemGroup.id}
                        >
                          {itemGroup.name}
                        </li>
                      );
                    }}
                  />
                  <a
                    className='btn full'
                    onClick={this.linkItemToGroup}
                    id='add_to_shared_item'
                  >
                    Share With Selected Existing {this.capitalTerminology()}
                  </a>
                </div>
              )}
            </form>
          </div>
        )}

        <Dialog
          actions={[
            <button
              key={'btn-submit'}
              className='btn warn'
              onClick={this.disableSharing}
            >
              Yes, Stop Sharing This Item
            </button>,
            <button
              key={'btn-cancel'}
              className='btn cancel'
              onClick={this.handleClose}
            >
              No
            </button>,
          ]}
          modal={false}
          open={disableModalOpen}
          className='dialog'
          bodyClassName='body'
          contentClassName='content'
          actionsContainerClassName='actions'
          overlayClassName='overlay'
          onRequestClose={this.handleClose}
        >
          <p>
            Are you sure you want to stop sharing this{' '}
            {this.displayTerminology()}?
          </p>
          <p>
            You will lose interaction between locations and this can’t be undone
          </p>
          <div>
            {checkLabels.map((check, index) => (
              <Checkbox
                key={check}
                checked={checks[index]}
                label={check}
                onCheck={(event, isChecked) =>
                  this.handleCheckbox(index, isChecked)
                }
              />
            ))}
          </div>
        </Dialog>
      </section>
    );
  }
}

export default connect(null, actions)(ShareItemContainer);
